import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from "../base/base.component";
import {RestClient} from "../rest-client.service";
import {BsaProfileInfoXBVO, PasswordChangeXBVO} from "../model/xbvo.model";
import {NgForm, NgModel, NgModelGroup} from "@angular/forms";
import {HttpResponse} from "@angular/common/http";
import {saveAs} from 'file-saver-es';
import { SelectItemsState } from '../base/state/select-items.state';
import { SelectItem } from 'primeng/api';
import { StringUtils } from '../base/utils/string.utils';

/**
 * App-Component
 */
@Component({
    selector: '<skitbs-profile>',
    templateUrl: 'profile.component.html'
})
export class ProfileComponent extends BaseComponent implements OnInit {

    modelXBVO: BsaProfileInfoXBVO;
    passwordChangeXBVO: PasswordChangeXBVO;

    modelOldPassword: string;
    modelNewPassword: string;
    modelNewPasswordConfirmation: string;

    modelIbanCOUNTRY = 'DE';
    modelIbanNR: string;
    modelConfirmedSepa = false;
    modelBicNR: string;

    @ViewChild('formEdit') public editForm: NgForm;

    /**
     * Constructor.
     * @param restClient
     */
    constructor(
        private restClient: RestClient,
        public selectItemsState: SelectItemsState
    ) {
        super();
    }

    /**
     * Lifecycle.
     */
    ngOnInit(): void {
        this.restClient.profileInfo().subscribe(aXBVO => this.loadModel(aXBVO));
        this.logi("VALID: " + this.editForm + "");
    }

    loadModel(aXBVO:BsaProfileInfoXBVO): void {
        this.modelXBVO = aXBVO;
        this.modelIbanCOUNTRY = aXBVO.sepaIBAN?.substring(0, 2);
        this.modelIbanNR = StringUtils.maskAsterisk(aXBVO.sepaIBAN?.substring(2));
        this.modelBicNR = aXBVO.sepaBIC;
        this.modelConfirmedSepa = aXBVO.sepaActive;
        setTimeout(()=>this.editForm.form.markAsPristine(), 0);
    }

    /**
     * Action.
     */
    onSave() {
        if (!this.editForm.valid) {
            this.toastViolation(this.v("invalid_form"));
            return;
        }
        this.restClient.saveProfile(this.modelXBVO)
          .subscribe(aProfileXBVO => {
            // completed
            this.loadModel(aProfileXBVO);
            this.toastInfo(this.v("operationComplete"))
        });
    }

    /**
     * Action.
     */
    onChangePassword() {
        // validation
        if (this.modelOldPassword == null) {
            this.toastViolation("Altes Passwort darf nicht leer sein.");
            return;
        }
        if (this.modelNewPassword == null || this.modelNewPassword.length < 8) {
            this.toastViolation(this.v("password_too_short"));
            return;
        }
        if (this.modelNewPassword.length > 50) {
            this.toastViolation(this.v("password_too_long"));
            return;
        }
        if (!/.*[a-z].*/.test(this.modelNewPassword)) {
            this.toastViolation(this.v("password_no_lowercase_letters"));
            return;
        }
        if (!/.*[A-Z].*/.test(this.modelNewPassword)) {
            this.toastViolation(this.v("password_no_uppercase_letters"));
            return;
        }
        if (!/.*[0-9].*/.test(this.modelNewPassword)) {
            this.toastViolation(this.v("password_no_numbers"));
            return;
        }
        if (!/[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(this.modelNewPassword)) {
            this.toastViolation(this.v("password_no_special_characters"));
            return;
        }
        // Only printable ASCII (0x21-0x7E) is allowed; rejects ä, ö, ü, ß, whitespace, etc.
        if (!/^[\x21-\x7E]+$/.test(this.modelNewPassword)) {
            this.toastViolation(this.v("password_non_ascii"));
            return;
        }
        if (this.modelNewPasswordConfirmation == null || this.modelNewPassword !== this.modelNewPasswordConfirmation) {
            this.toastViolation("Neues Passwort und Passwortbestätigung passen nicht zusammen.");
            return;
        }

        this.passwordChangeXBVO = new PasswordChangeXBVO();
        this.passwordChangeXBVO.oldPassword = this.modelOldPassword;
        this.passwordChangeXBVO.newPassword = this.modelNewPassword;
        this.passwordChangeXBVO.newPasswordConfirmation = this.modelNewPasswordConfirmation;

        this.restClient
            .changePassword(this.passwordChangeXBVO)
            .subscribe(aResponseXBVO => {
              if (aResponseXBVO.code === 200) {
                this.modelOldPassword = "";
                this.modelNewPassword = "";
                this.modelNewPasswordConfirmation = "";
                return this.toastOperationComplete()
              } else {
                return this.toastViolation(aResponseXBVO.errorDescription);
              }
            });

    }

    /**
     * Action.
     */
    onDownloadContract() {
        this.restClient
            .downloadContractPDF()
            .subscribe((response: HttpResponse<Blob>) => {

                // missing contract on server ?
                if (!response.body.size) {
                    this.toastViolation("Verpflegungsvertrag ist nicht vorhanden!");
                    return;
                }

                var blob = new Blob([response.body], {type: 'application/pdf'});
                var filename = response.headers.get('Content-Disposition').split(';')[1].split('filename')[1].split('=')[1].trim();
                saveAs(blob, filename);
            });
    }

    /**
     * Action.
     */
    onDownloadSepa() {
        this.restClient
            .downloadSepaPDF()
            .subscribe((response: HttpResponse<Blob>) => {
                var blob = new Blob([response.body], {type: 'application/pdf'});
                var filename = response.headers.get('Content-Disposition').split(';')[1].split('filename')[1].split('=')[1].trim();
                saveAs(blob, filename);
            });
    }

    onIbanChanged(ngModel: NgModel) {
        this.onBankDataChanged();

        if (!this.modelXBVO.sepaActive && this.modelIbanNR === "") {
            this.modelXBVO.sepaIBAN = null;
            return;
        }

        this.modelXBVO.sepaIBAN = this.modelIbanCOUNTRY + "" + this.modelIbanNR;
        this.restClient.callValidateIBAN(this.modelIbanCOUNTRY + "" + this.modelIbanNR).subscribe({
            error: err => ngModel.control.setErrors({
                ibanValidatorMessage: this.i18n.v("invalidIBAN"),
                ibanValidatorDetails: "[ERR] " + err.errorDescription
            })
        });
    }

    onIbanFocus(ngModel: NgModel){
        if (!ngModel.dirty) this.modelIbanNR = '';
    }

    onIbanFocusOut(ngModel: NgModel){
        if (!ngModel.dirty) this.modelIbanNR = StringUtils.maskAsterisk(this.modelXBVO.sepaIBAN?.substring(2));
    }

    onBicChanged(ngModel: NgModel) {
        this.onBankDataChanged();

        if (this.modelBicNR === "") {
            this.modelXBVO.sepaBIC = null;
            return;
        }

        this.modelXBVO.sepaBIC = this.modelBicNR;
        this.restClient.callValidateBIC(this.modelBicNR).subscribe({
            error: err => ngModel.control.setErrors({
                bicValidatorMessage: this.i18n.v("invalidBIC"),
                bicValidatorDetails: "[ERR] " + err.errorDescription
            })
        });
    }

    onBankDataChanged(event?:any) : void {
        this.modelXBVO.sepaChanged = true;
        this.modelConfirmedSepa = false;
    }

    onTakeoverAccountOwner() {
        this.modelXBVO.sepaAccountOwner = this.modelXBVO.cpName;
        this.modelXBVO.sepaAccountOwnerAddr =
            this.modelXBVO.cpAddr.zip + " " +
            this.modelXBVO.cpAddr.city + ", " +
            this.modelXBVO.cpAddr.streetName + " " +
            this.modelXBVO.cpAddr.streetNr;
    }

    canSave():boolean {
        if (this.modelXBVO.sepaChanged && !this.modelConfirmedSepa) return false;
        return this.editForm.dirty && this.editForm.valid;
    }
}
